import { PickerColumnItem } from "./PickerView/PickerView";

export const defaultRenderLabel = (item: PickerColumnItem) => item.label;
